const yndVariantRequests = new WeakMap();
const yndInitializeProduct = (section) => {
  const pickers = section.querySelector('[data-option-pickers]');
  if (pickers) pickers.hidden = false;
};
document.querySelectorAll('[data-product-section]').forEach(yndInitializeProduct);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-product-section]').forEach(yndInitializeProduct);
});
document.addEventListener('change', async (event) => {
  if (event.target.matches('[data-sort-select]')) event.target.form.requestSubmit();
  if (!event.target.matches('[data-option-position]')) return;
  const picker = event.target;
  const section = picker.closest('[data-product-section]');
  if (!section) return;
  const chosenOption = picker.selectedOptions[0];
  const productUrl = chosenOption?.dataset.productUrl || section.dataset.productUrl;
  const optionValues = [...section.querySelectorAll('[data-option-position]')]
    .map(select => select.selectedOptions[0]?.dataset.optionValueId).filter(Boolean);
  const destination = new URL(productUrl, window.location.origin);
  destination.searchParams.set('option_values', optionValues.join(','));
  if (new URL(productUrl, window.location.origin).pathname !== new URL(section.dataset.productUrl, window.location.origin).pathname) {
    window.location.assign(destination);
    return;
  }
  const requestUrl = new URL(destination);
  requestUrl.searchParams.set('section_id', section.dataset.sectionId);
  const previousRequest = yndVariantRequests.get(section);
  if (previousRequest) previousRequest.abort();
  const controller = new AbortController();
  yndVariantRequests.set(section, controller);
  const button = section.querySelector('[data-add-to-bag]');
  const variantInput = section.querySelector('[data-variant-id]');
  button.disabled = true;
  variantInput.disabled = true;
  section.dataset.variantLoading = 'true';
  section.setAttribute('aria-busy', 'true');
  try {
    const response = await fetch(requestUrl, { signal: controller.signal });
    if (!response.ok) throw new Error('Product options could not be loaded');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const nextSection = html.querySelector('[data-product-section]');
    const nextInput = nextSection?.querySelector('[data-variant-id]');
    const nextPickers = nextSection?.querySelector('[data-option-pickers]');
    if (!nextSection || !nextInput || !nextPickers || nextSection.dataset.sectionId !== section.dataset.sectionId) throw new Error('Product options were not returned');
    if (yndVariantRequests.get(section) !== controller) return;
    nextPickers.hidden = false;
    section.querySelector('[data-option-pickers]').replaceWith(nextPickers);
    section.querySelector('[data-variant-price]').textContent = nextSection.querySelector('[data-variant-price]').textContent;
    const nextGallery = nextSection.querySelector('.ynd-product-gallery');
    if (nextGallery) section.querySelector('.ynd-product-gallery').replaceWith(nextGallery);
    variantInput.value = nextInput.value;
    variantInput.disabled = nextInput.disabled || !nextInput.value;
    const available = nextSection.dataset.variantAvailable === 'true' && !variantInput.disabled;
    section.dataset.selectedVariantId = nextInput.value;
    section.dataset.variantAvailable = String(available);
    section.dataset.variantCount = nextSection.dataset.variantCount;
    button.disabled = !available;
    button.textContent = available ? button.dataset.availableLabel : button.dataset.unavailableLabel;
    const pageUrl = new URL(window.location.href);
    pageUrl.searchParams.delete('section_id');
    pageUrl.searchParams.delete('variant');
    pageUrl.searchParams.delete('option_values');
    if (nextInput.value) pageUrl.searchParams.set('variant', nextInput.value);
    else pageUrl.searchParams.set('option_values', optionValues.join(','));
    history.replaceState({}, '', pageUrl);
    section.querySelector('[data-option-position="' + picker.dataset.optionPosition + '"]')?.focus({ preventScroll: true });
    section.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variantId: nextInput.value || null, available } }));
  } catch (error) {
    if (error.name !== 'AbortError') window.location.assign(destination);
  } finally {
    if (yndVariantRequests.get(section) === controller) {
      yndVariantRequests.delete(section);
      delete section.dataset.variantLoading;
      section.removeAttribute('aria-busy');
    }
  }
});
document.addEventListener('submit', (event) => {
  const section = event.target.closest('[data-product-section]');
  if (!section || !event.target.querySelector('[data-variant-id]')) return;
  const variantInput = event.target.querySelector('[data-variant-id]');
  if (section.dataset.variantLoading === 'true' || section.dataset.variantAvailable !== 'true' || variantInput.disabled || !variantInput.value) event.preventDefault();
});
document.addEventListener('click', (event) => {
  const mobile = document.querySelector('.ynd-mobile-nav');
  if (mobile && event.target.closest('.ynd-mobile-nav a')) mobile.open = false;
  document.querySelectorAll('.ynd-header details[open]').forEach(detail => {
    if (!detail.contains(event.target)) detail.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('.ynd-header details[open]').forEach(detail => { detail.open = false; detail.querySelector('summary').focus(); });
});
